import {RadioGroup} from '@headlessui/react'
import Grid from "../Grid";
import GridItem from "../GridItem";
import {br, cl, pad} from '../theme';
import cx from '../../../app/editor/utils/makeCls';
import Tooltip from "../Tooltip";

export default function ButtonGroupField({className, options, value, size = 'm', onChange,}) {
    const isLast = (id) => {
        const item = options.filter((opt) => opt.id === id)[0];
        return options.indexOf(item) === (options.length - 1);
    }

    const getItemCls = (checked, id) => cx(
        'cursor-pointer',
        size === 'm' && pad.xy,
        size === 's' && 'px-2 py-1.5',
        size === 'xs' && 'px-2 py-1',
        cl.br,
        checked && cl.bgO,
        !isLast(id) && br.br
    );

    return (
        <RadioGroup value={value} onChange={onChange} className="w-full">
            <Grid className={cx(className, br.b, br.rnd, cl.br, 'cursor-pointer')} items="center" full nowrap>
                {
                    options.map(({id, label, title}) => (
                        <Tooltip title={title} key={id} className="w-full" classNameWrp="flex-1">
                            <RadioGroup.Option value={id} className={({checked}) => getItemCls(checked, id)}>
                                <Grid justify="center" full>
                                    <GridItem>{label}</GridItem>
                                </Grid>
                            </RadioGroup.Option>
                        </Tooltip>
                    ))
                }
            </Grid>
        </RadioGroup>
    );
}